import React from 'react';
import { Box, IconButton, styled } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import HeadphonesIcon from '@mui/icons-material/Headphones';

const SocialIconButton = styled(IconButton)(({ theme, selected }) => ({
  backgroundColor: selected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)',
  margin: theme.spacing(1),
  border: `1px solid ${selected ? theme.palette.primary.main : 'rgba(255, 255, 255, 0.1)'}`,
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}));

const SocialButtons = ({ socials, handleSocialChange }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 4 }}>
      <SocialIconButton 
        selected={socials.linkedin} 
        onClick={() => handleSocialChange('linkedin')}
        aria-label="LinkedIn"
      >
        <LinkedInIcon sx={{ color: socials.linkedin ? '#0077B5' : '#fff' }} />
      </SocialIconButton>
      <SocialIconButton 
        selected={socials.instagram} 
        onClick={() => handleSocialChange('instagram')}
        aria-label="Instagram"
      >
        <InstagramIcon sx={{ color: socials.instagram ? '#E1306C' : '#fff' }} />
      </SocialIconButton>
      <SocialIconButton 
        selected={socials.discord} 
        onClick={() => handleSocialChange('discord')}
        aria-label="Discord"
      >
        <HeadphonesIcon sx={{ color: socials.discord ? '#5865F2' : '#fff' }} />
      </SocialIconButton>
    </Box>
  );
};

export default SocialButtons;